/* unplugin-vue-components disabled */import script from "./StockRoomConfigure.vue?vue&type=script&setup=true&lang=js"
export * from "./StockRoomConfigure.vue?vue&type=script&setup=true&lang=js"

import "./StockRoomConfigure.vue?vue&type=style&index=0&id=6d8bd0da&lang=scss"
import "./StockRoomConfigure.vue?vue&type=style&index=1&id=6d8bd0da&lang=scss&scoped=true"
import "./StockRoomConfigure.vue?vue&type=style&index=2&id=6d8bd0da&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8bd0da"]])

export default __exports__